import { SystemFuncArgs } from '$legacyecstatic';
import Canvas from 'editor/components/Canvas';
import { getSheetToScreenTransform } from 'editor/utils/transform';
import { Components } from '../components';
import DrawTempRectInteraction from '../components/interactions/DrawTempRectInteraction';

export const renderTempRectComponents = [DrawTempRectInteraction, Canvas];

// NOTE: Might want to update this so that it can be used more generically,
//       Maybe something like renderBasicRect, or something.
export function renderTempRect(args: SystemFuncArgs<Components>): void {
  const { entity, world } = args;

  const interaction = entity.get(DrawTempRectInteraction);
  const { originX, originY, currentX, currentY, stroke, strokeWidth } =
    interaction;
  const canvasComp = entity.get(Canvas);

  const ctx = canvasComp.canvas.getContext('2d');

  if (ctx) {
    ctx.save();

    const transform = getSheetToScreenTransform(world);
    ctx.transform(...transform);

    ctx.strokeStyle = stroke;
    ctx.lineWidth = strokeWidth;

    ctx.strokeRect(originX, originY, currentX - originX, currentY - originY);

    ctx.restore();
  }
}
